import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import styled, { css } from 'styled-components';

import customTheme from 'app/style/theme';

import { Box, Heading } from 'grommet';
import Highlighter from 'react-highlight-words';

import AppState from 'app/state/AppState';
import MenuPane from 'app/components/Menu/MenuPane';

// eslint-disable-next-line import/no-webpack-loader-syntax
import worker from 'worker-loader!app/api/search.worker.js';
const searchWorker = new worker();
searchWorker.onmessage = ({ data: results }) => {
  const hasResults = !_.isEmpty(results.matches);
  if (hasResults) {
    AppState.changeSearchStatus('SEARCH_RESULTS_FOUND');
    AppState.newSearchResults(results);
  } else {
    AppState.changeSearchStatus('SEARCH_RESULTS_EMPTY');
  }
};

const StyledHeader = styled(Heading)`
  margin: 0px 0;
  ${props =>
    props.searchTerm &&
    css`
      font-style: italic;
    `};
`;

const HighlighterParagraph = styled(Highlighter)`
  margin: 10px 0;
  hyphens: auto;
  cursor: pointer;
  .highlight {
    color: ${customTheme.global.colors.black};
    background-color: ${customTheme.global.colors.focus}
  }
`;

function SearchResults({ AppState }) {
  if (!AppState.isSearchResultsOpen) return null;
  const {
    searchTerm,
    isSearchResultsPending,
    isSearchResultsFound,
    isSearchResultsEmpty,
  } = AppState;
  if (isSearchResultsPending) {
    searchWorker.postMessage(searchTerm);
  }
  return (
    <MenuPane>
      <Box direction="column" justify="center" align="center">
        <StyledHeader responsive size="small" textAlign="center">
          Search Results
        </StyledHeader>
      </Box>
      {isSearchResultsPending && <p>Searching...</p>}
      {isSearchResultsEmpty && <p>No matches found!</p>}
      {isSearchResultsFound &&
        _.map(
          AppState.searchResults.matches,
          ({ path, value }, index, matches) => (
            <Box
              key={index}
              border={index !== matches.length - 1 ? 'bottom' : undefined}
              flex="grow"
              margin={{ horizontal: 'none' }}
              onClick={() => {
                AppState.changeSectionItem(path);
                AppState.toggleSearchResults();
              }}
            >
              <HighlighterParagraph
                highlightClassName="highlight"
                searchWords={searchTerm.split(' ')}
                autoEscape={true}
                textToHighlight={value}
              />
            </Box>
          )
        )}
    </MenuPane>
  );
}

export default inject('AppState')(observer(SearchResults));



// WEBPACK FOOTER //
// ./src/app/components/SearchResults.js